<script setup lang="ts">
import { inject } from "vue";
import { APP } from "@/stores/app";

const appStore = inject(APP)!;
</script>

<template>
  <div :class="{ 'deck-loading-screen': true, 'deck-loading-screen-transparent': appStore.dev }">
    <div class="deck-loading-screen-logo"></div>
    <div class="deck-loading-screen-progress-bar">
      <div class="deck-loading-screen-animation"></div>
    </div>
  </div>
</template>

<style>
@keyframes continuous {
  0% {
    width: 0;
    margin-left: 0;
  }
  100% {
    width: 100%;
    margin-left: 100%;
  }
}

@keyframes progress {
  0% {
    width: 0;
  }
  33.33% {
    width: 80%;
  }
  100% {
    width: 100%;
  }
}

.deck-loading-screen {
  position: absolute;
  z-index: 100;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  pointer-events: none;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--deck-loading-screen-color, black);
}

.deck-loading-screen-transparent {
  background-color: color-mix(in srgb, var(--deck-loading-screen-color, black) 30%, transparent);
}

.deck-loading-screen-progress-bar {
  position: absolute;
  height: 5px;
  width: 35%;
  top: 65%;
  background-color: var(--deck-loading-screen-progress-bar-color, white);
  outline: 0.25px solid var(--deck-loading-screen-progress-bar-border-color, transparent);
  overflow: hidden;
}

.deck-loading-screen-animation {
  height: 100%;
  background-color: var(--deck-loading-screen-progress-color, #f50537);
  animation: var(--deck-loading-bar-animation, continuous ease-in 1s infinite);
}

.deck-loading-screen-logo {
  position: absolute;
  width: 30%;
  height: 30%;
  top: 25%;
  background-image: var(--deck-loading-screen-logo);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}
</style>
